import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    todayLoginCount: { default: 15 },
    todaySuccessCount: { default: 14 },
    todayFailedCount: { default: 5 }
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()
const statisticsItems = computed(() => [
  { label: t('remoteAuth.todayLoginCount'), value: props.todayLoginCount, span: 8 },
  { label: t('remoteAuth.todaySuccessCount'), value: props.todaySuccessCount, span: 8 },
  { label: t('remoteAuth.todayFailedCount'), value: props.todayFailedCount, span: 8 }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})